import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { extractContent } from "./utils";
export default function formConfigReducer(state = initialState.formConfig, action) {
	switch (action.type) {
		case types.SET_FORM_CONFIG_TYPE:
			return { ...state, configType: action.payload.type };
		case types.UPDATE_ENTIRE_FORM_CONFIG:
			return { ...action.payload };
		case types.UPDATE_FORM_CONFIG:
			if (action.payload && action.payload.type == "styleClass") {
				return { ...state, styleClasses: action.payload.styleClasses };
			}
			if (state.configType == "CONFIRMATION_MESSAGE") {
				const { messageBody } = action.payload;
				const messageText = extractContent(messageBody);
				return { ...state, messageBody, messageText };
			}
			if (state.configType == "REDIRECT_WORDPRESS_PAGE") {
				const { redirectWordpressPage } = action.payload;
				return { ...state, redirectWordpressPage };
			}
			if (state.configType == "REDIRECT_EXTERNAL_PAGE") {
				const { redirectExternalPage } = action.payload;
				return { ...state, redirectExternalPage };
			}
			return state;
		default:
			return state;
	}
}
